import { render, staticRenderFns } from "./Pep-statement-question.vue?vue&type=template&id=361c9679&scoped=true"
import script from "./Pep-statement-question.vue?vue&type=script&lang=js"
export * from "./Pep-statement-question.vue?vue&type=script&lang=js"
import style0 from "./Pep-statement-question.vue?vue&type=style&index=0&id=361c9679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361c9679",
  null
  
)

export default component.exports